var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host page"},[_c('DataTable',{attrs:{"title":"Сотрудники","service":_vm.service,"fields":_vm.tableFileds,"scheme":_vm.scheme,"pageSize":5,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }